<template>
  <div v-if="show" class="update-splash">
    <div class="splash-content">
      <div class="splash-icon">
        <img src="/img/svg/update.svg" alt="update" class="icon" />
      </div>
      <h1 class="splash-title">{{ $t('updateAvailable') }}</h1>
      <p class="splash-message">{{ $t('updateMessage') }}</p>
      <button @click="handleUpdate" class="update-btn">
        {{ $t('update') }}
      </button>
    </div>
  </div>
</template>

<script>
import { updateStoredVersion } from '../utils/versionChecker'

export default {
  name: 'UpdateSplash',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleUpdate() {
      // Update stored version before refresh
      await updateStoredVersion()
      // Force refresh the page
      window.location.reload(true)
    }
  }
}
</script>

<style scoped>
.update-splash {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  direction: rtl;
}

.splash-content {
  text-align: center;
  padding: 40px 20px;
  max-width: 400px;
  width: 100%;
}

.splash-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: #f0f4ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.icon {
  width: 48px;
  height: 48px;
  animation: update-spin 1.2s linear infinite;
}

@keyframes update-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.splash-title {
  font-size: 24px;
  font-weight: bold;
  color: #1c274c;
  margin: 0 0 16px 0;
}

.splash-message {
  font-size: 16px;
  color: #64748b;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

.update-btn {
  background: #1c39bb;
  color: white;
  border: none;
  padding: 14px 48px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 4px 12px rgba(28, 57, 187, 0.3); */
  width: 100%;
  max-width: 280px;
}

.update-btn:hover {
  background: #15309a;
  transform: translateY(-2px);
  /* box-shadow: 0 6px 16px rgba(28, 57, 187, 0.4); */
}

.update-btn:active {
  transform: translateY(0);
  /* box-shadow: 0 2px 8px rgba(28, 57, 187, 0.3); */
}

/* Mobile responsive */
@media (max-width: 480px) {
  .splash-content {
    padding: 30px 20px;
  }

  .splash-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 20px;
    padding: 16px;
  }

  .icon {
    width: 36px;
    height: 36px;
  }

  .splash-title {
    font-size: 20px;
    margin-bottom: 12px;
  }

  .splash-message {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .update-btn {
    padding: 12px 32px;
    font-size: 15px;
  }
}
</style>

